import Vue from 'vue';
import Vuex from 'vuex';
import { AuthStore, AUTH_STORE } from '@/auth/store/auth.store';
import { AppStore, APP_STORE } from './app.store';
import { CalendarStore, CALENDAR_STORE } from './calendar.store';
import { SchoolCalendarStore, SCHOOL_CALENDAR_STORE } from '@/tools/store/school-calendar.store';
import { MyContentStore, MY_CONTENT_STORE } from '@/app/private/my-content/store/my-content.store';
import { CourseStore, COURSE_STORE } from '@/courses/store/course.store';
import { TeacherPortalStore, TEACHER_PORTAL_STORE } from '@/content/pages/teacher-portal/teacher-portal.store';
import { ToolsStore, TOOLS_STORE } from '@/tools/store/tools.store';
import { HomeworksStore, HOMEWORKS_STORE } from '@/homework/store/homeworks.store';
import { TemplatesStore, TEMPLATES_STORE } from '@/templates/store/templates.store';
import { MeetingsStore, MEETINGS_STORE } from '@/meetings/store/meetings.store';
import { ClassesStore, CLASSES_STORE } from '@/classes/store/classes.store';
import { ScreenMirroringStore, SCREEN_MIRRORING_STORE } from '@/screen-mirroring/store/screen-mirroring.store';
import { CourseTemplateStore } from '@/course-templates/store/course-templates.store';
import { PreferencesStore } from '@/preferences/store/preferences.store';
import { CallsStore, CALLS_STORE } from '@/components/calls/store/calls.store';
import { StaffStore, STAFF_STORE } from '@/tools/store/staff.store';
import { UserRequestsStore, USER_REQUESTS_STORE } from '@/app/private/user-requests/store/user-requests.store';
import { SubstituteTeacherStore, SUBSTITUTE_TEACHER_STORE } from '@/tools/store/substitute-teacher.store';
import { ScreenShareStore, SCREEN_SHARE_STORE } from '@/components/screen-share/store/screen-share.store';


Vue.use(Vuex);

export interface ICoreStore {
  AppStore: AppStore,
  AuthStore: AuthStore,
  ToolsStore: ToolsStore,
  CalendarStore: CalendarStore,
  SchoolCalendarStore: SchoolCalendarStore,
  MyContentStore: any,
  TeacherPortalStore: any,
  CourseStore: any,
  HomeworksStore: HomeworksStore,
  TemplatesStore: TemplatesStore,
  MeetingsStore: MeetingsStore,
  ClassesStore: ClassesStore,
  CourseTemplates: CourseTemplateStore,
  PreferencesStore: PreferencesStore,
  StaffStore: StaffStore,
  ScreenMirroringStore: ScreenMirroringStore,
  CallsStore: CallsStore,
  UserRequestsStore: UserRequestsStore,
  SubstituteTeacherStore: SubstituteTeacherStore,
  ScreenShareStore: ScreenShareStore
}

export const Store = new Vuex.Store<ICoreStore>({
  modules: {
    AppStore,
    AuthStore,
    MyContentStore,
    CourseStore,
    TeacherPortalStore,
    ToolsStore,
    CalendarStore,
    SchoolCalendarStore,
    HomeworksStore,
    TemplatesStore,
    MeetingsStore,
    ClassesStore,
    CourseTemplateStore,
    PreferencesStore,
    StaffStore,
    ScreenMirroringStore,
    CallsStore,
    UserRequestsStore,
    SubstituteTeacherStore,
    ScreenShareStore
  }
});

export const STORE = {
  APP: APP_STORE,
  AUTH: AUTH_STORE,
  TEACHER_PORTAL: TEACHER_PORTAL_STORE,
  COURSE: COURSE_STORE,
  TOOLS: TOOLS_STORE,
  MY_CONTENT: MY_CONTENT_STORE,
  CALENDAR: CALENDAR_STORE,
  SCHOOL_CALENDAR: SCHOOL_CALENDAR_STORE,
  HOMEWORKS: HOMEWORKS_STORE,
  TEMPLATES: TEMPLATES_STORE,
  MEETINGS_STORE: MEETINGS_STORE,
  CLASSES_STORE: CLASSES_STORE,
  CALLS_STORE: CALLS_STORE,
  SCREEN_MIRRORING_STORE: SCREEN_MIRRORING_STORE,
  STAFF_STORE: STAFF_STORE,
  USER_REQUESTS_STORE: USER_REQUESTS_STORE,
  SUBSTITUTE_TEACHER_STORE: SUBSTITUTE_TEACHER_STORE,
  SCREEN_SHARE_STORE: SCREEN_SHARE_STORE
}

const resetModuleState = (module: any) => {
  if (module._rawModule) {
    const rawData = module._rawModule;
    if(rawData.mutations) {
      const mutations = rawData.mutations;
      if(mutations.initState) {
        mutations.initState(module.state);
      }
    }
    
  }
}

export const resetAllModuleStates = () => {
  const allModules = Store['_modules'];
  Object.keys(allModules).forEach((moduleName) => {
    const module = allModules[moduleName];
    if (module['_children']) {
      const subModules = module['_children'];
      Object.keys(subModules).forEach((subModuleName) => {
        const subModule = subModules[subModuleName];
        resetModuleState(subModule);
      });
    }
  });
}
